
import Vue from "vue";
import Component from "vue-class-component";
import { Action, Mutation, State } from "vuex-class";

import { SchoolModel } from "@/models/academy.model";
import { CandidateModel } from "@/models/candidate.model";
import { isUniversity } from "@/functions/userinterface.function";

// import Active from "./candidate/Active.vue";
// import Inactive from "./candidate/Inactive.vue";
import Import from "./candidate/Import.vue";
import Verify from "./candidate/Verify.vue";
import SendInvitation from "./candidate/SendInvitation.vue";
import CandidateInviteList from "./candidate/CandidateInviteList.vue";

@Component({
  components: {
    // Active,
    // Inactive,
    Import,
    // Verify,
    SendInvitation,
    CandidateInviteList
  }
})
export default class EmailInvitation extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("actionSelectCandidateActive", { namespace: "candidate" })
  private actionSelectCandidateActive: any;
  @Action("actionSelectCandidateInactive", { namespace: "candidate" })
  private actionSelectCandidateInactive: any;
  @Action("actionResetCandidate", { namespace: "candidate" })
  private actionResetCandidate: any;
  @Action("actionSelectCandidateExport", { namespace: "candidate" })
  private actionSelectCandidateExport: any;

  // STATE
  @State("school", { namespace: "academy" })
  private school: SchoolModel;
  @State("pagination_candidate_active", { namespace: "candidate" })
  private pagination_candidate_active: any;
  @State("pagination_candidate_inactive", { namespace: "candidate" })
  private pagination_candidate_inactive: any;
  @State("pagination_verify", { namespace: "candidate" })
  private pagination_verify: any;
  @State("candidate", { namespace: "candidate" })
  private candidate: any;

  // MUTATION
  @Mutation("mutationCandidate", {namespace: "candidate"})
  private mutationCandidate: any;

  /* INITIALIZATION */

  private tabImport: boolean = true;
  private tabInactive: boolean = false;
  // private tabImport: boolean = false;
  // private tabVerify: boolean = false;
  private onList: boolean = false;
  private tabs: any = null;

  constructor() {
    super();
  }

  private get wordingInvitedStudent() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("invited_students_2");
    }

    return this.$i18n.t("invited_students");
  }

  /* LIFECYCLE */

  private created() {
    this.getTab();
    this.actionResetCandidate();
    // this.actionSelectCandidateActive();
  }

  /* METHODS */

  private activateTab(label: string) {
    // Disable all
    for (const key in this.$data) {
      if (key) {
        this.$data[key] = false;
      }
    }

    // Enable selected
    this.$data[label] = true;
  }

  private onSearch() {
    (this.$refs.searchCandidateInvite as any).hide();
    this.actionSelectCandidateInactive();
  }

  private onReset() {
    this.mutationCandidate(new CandidateModel());
    this.onSearch();
    (this.$refs.searchCandidateInvite as any).hide();
  }

  private getTab() {
    const tabEmailInvitation = localStorage.getItem('TabEmailInvitation');
    if (tabEmailInvitation) {
      this.tabs = parseInt(tabEmailInvitation);
    } else {
      this.tabs = 0;
    }
  }

  private setTab() {
    if (this.tabs === 0) {
      this.onList = true;
      localStorage.setItem('TabEmailInvitation', "1");
    } else {
      this.onList = false;
      localStorage.setItem('TabEmailInvitation', "0");
    }
  }
}
